import { BaseComponent } from '../../base-component';
import { emitProductComparisonLoadedEvent } from './product-comparison';

export class ProductComparisonApiComponent extends BaseComponent {
    public rootSelector = '.js_pdp_product-comparison-api';

    public async init(): Promise<void> {
        emitProductComparisonLoadedEvent(o_global.eventQBus);
    }

    public async onHtmlLoaded(): Promise<void> {
        /*            */
    }
}
